import { httpBus } from "@/api/index.js";
export { getMeterList as queryStationMeterList } from "@/api/modules/device/meter.js";



/**
 * 查询收益信息
 * @param {*} stationId 
 * @param {*} meterUuid ''表示查询全部电表的数据
 * @param {*} startTime 
 * @param {*} endTime 
 * @param {*} timeUint 'day' | 'month' | 'year'
 * @returns 
 */
export function queryIncomeInfoByTimeRange({stationId, meterUuid, startTime, endTime, timeUint}) {
  const params = {
    stationId,
    type: timeUint,
    startTime,
    endTime,
    uuid: meterUuid,
  }
  return httpBus.request("get", "/dashboard/income/listByTime", { params });
};



/**
 * 获取异常信息
 * @param {*} stationId 
 * @param {*} startTime 
 * @param {*} endTime 
 * @returns 
 * >>> errorNum: 电表数据异常的天数
 * >>> missNum: 电表数据丢失的天数
 */
export function queryAbnormalInfo({stationId, startTime, endTime}) {
  return httpBus.request("get", "/dashboard/income/getAbnormalInfo", {
    params: {
      stationId,
      startTime,
      endTime
    }
  });
};


